import { useLanguage } from '../i18n/LanguageContext';
import './LanguageSwitcher.css';

const locales = [
  { code: 'en', label: 'EN' },
  { code: 'ru', label: 'RU' },
];

function LanguageSwitcher() {
  const { locale, setLocale } = useLanguage();

  return (
    <div className="lang-switcher" role="group" aria-label="Language">
      {locales.map(({ code, label }) => (
        <button
          key={code}
          type="button"
          className={locale === code ? 'active' : ''}
          onClick={() => setLocale(code)}
          aria-pressed={locale === code}
        >
          {label}
        </button>
      ))}
    </div>
  );
}

export default LanguageSwitcher;
